var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.environment
    ? _c(
        "div",
        { staticClass: "page vld-parent" },
        [
          _c("loading", {
            attrs: {
              active: _vm.isLoading,
              "is-full-page": false,
              loader: "bars",
            },
          }),
          _c("div", { staticClass: "page-main" }, [
            _c("div", { staticClass: "page-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
                },
                [
                  _c("h1", { staticClass: "page-title" }, [_vm._v("Samurai")]),
                  _c("breadcrumb", {
                    attrs: {
                      name: "GAME_SAMURAI_SETTINGS_DETAIL",
                      withLast: _vm.environment.name,
                    },
                    on: {
                      "update:withLast": function ($event) {
                        return _vm.$set(_vm.environment, "name", $event)
                      },
                      "update:with-last": function ($event) {
                        return _vm.$set(_vm.environment, "name", $event)
                      },
                    },
                  }),
                  _c("div", { staticClass: "page-title page-header-actions" }, [
                    _c(
                      "span",
                      { staticClass: "save-badge", class: _vm.saveStateClass },
                      [_vm._v(" " + _vm._s(_vm.saveStateText) + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-round btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.goBack },
                      },
                      [
                        _c("i", {
                          staticClass: "icon mdi mdi-chevron-left mdi-18px",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back "),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "page-content container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
                  },
                  [
                    _c("div", { staticClass: "panel panel-bordered mb-30" }, [
                      _c("div", { staticClass: "panel-heading" }, [
                        _c("h3", { staticClass: "panel-title" }, [
                          _vm._v(
                            " Ufu Settings - " +
                              _vm._s(_vm.environment.name) +
                              " "
                          ),
                        ]),
                        _c("div", {
                          staticClass: "panel-actions panel-actions-keep",
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "panel-body" },
                        [
                          _c("EnvironmentConfigForm", {
                            attrs: {
                              value: _vm.form,
                              themes: _vm.themes,
                              "save-state": _vm.saveState,
                            },
                            on: {
                              change: _vm.onFormChange,
                              blur: _vm.onFormBlur,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("QuestionList", {
                      attrs: { code: _vm.environment.code },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }